import { Link } from "react-router-dom";
import lft from "../images/Lft.svg";
// import logo2 from "../images/logo.svg";

function Index() {
  return (
    <div className="index">
      <div
        className="text-white flex items-center justify-center h-screen"
        style={{
          backgroundImage: "url(" + lft + ")",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <div className="mx-auto max-w-lg p-4 py-5 w-[600px]">
          <div className="flex gap-6 flex-col text-center">
            <div className="mb-5">
              <h1 className="tfont-bold pb-3 pt-3 text-[45px] font-bolder">
                Welcome to
              </h1>
              <div className="flex items-center justify-center text-xl mb-5">
                {/* check logo  */}
                <img src="images/Logo (2)-white.png" alt="logo" />
              </div>
            </div>

            <p className="mb-5 pb-4 text-[20px]">
              Easily manage your business financial operations in crypto
            </p>

            <Link
              to="/login"
              className="block bg-secondary w-full h-[50px] text-white bg-secondary hover:bg-secondary/40 transition ease-in duration-200 text-center text-base font-semibold shadow-md rounded flex items-center justify-center"
            >
              Get Started
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Index;
